import React from 'react';
import Checkout from './Checkout';

const CheckoutContainer = () => <Checkout />;
export default CheckoutContainer;
